<template>
  <div class="step">
    <h2>I tuoi dati</h2>
    <p class="subtitle text-medium">
      Tutti i campi sono obbligatori
    </p>
    <div class="fieldset">
      <Input
        v-model="params.name"
        :max-length="30"
        type="text"
        :auto-focus="true"
        :disabled="isCompleteProfile"
        placeholder="Nome"
        :regex="regex.text"
        @error="updateErrors"
      />
      <Input
        v-model="params.surname"
        :max-length="30"
        type="text"
        placeholder="Cognome"
        :regex="regex.text"
        :disabled="isCompleteProfile"
        @error="updateErrors"
      />
      <Input
        v-if="showRole"
        v-model="params.role"
        :max-length="30"
        type="text"
        placeholder="Ruolo"
        :regex="regex.text"
        @error="updateErrors"
      />
      <Input
        v-model="params.phone"
        type="number"
        placeholder="Telefono"
        :regex="regex.number"
        @error="updateErrors"
      />
    </div>
    <div class="actions">
      <button
        class="button primary"
        :disabled="disabled"
        @click="!disabled ? navigate('next') : null"
      >
        Avanti
      </button>
      <button
        class="back"
        @click="navigate('prev')"
      >
        Torna indietro
      </button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import { GestioneProfili } from '../../common/utenze';

import Input from '../shared/InputComponent.vue';

Vue.use(VueLodash, { lodash });

const _ = require('lodash');

export default {
  name: 'DatiPersonali',
  components: {
    Input,
  },
  props: {
    preset: {
      type: Object,
      default: () => {},
    },
    profileId: {
      type: String,
      required: true,
    },
    isCompleteProfile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      params: {
        name: null,
        surname: null,
        role: null,
        phone: null,
      },
      regex: {
        text: [
          {
            rule: /^[a-z àáèéìíòóùú,.'-]+$/i,
            msg: 'Formato non valido',
          },
        ],
        number: [
          {
            rule: /^[0-9]{6,25}$/,
            msg: 'Formato non valido',
          },
        ],
      },
      errorsCounter: 0,
    };
  },
  computed: {
    showRole() {
      return _.includes(GestioneProfili.ConRuolo, this.profileId);
    },
    disabled() {
      const { errorsCounter, params } = this;
      const {
        name, surname, role, phone,
      } = params;
      return (
        errorsCounter || !name || !surname || (this.showRole && !role) || !phone
      );
    },
  },
  watch: {
    preset: {
      handler(v) {
        if (!_.isEmpty(v)) {
          this.params = v;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.$emit('push-event');
  },
  methods: {
    navigate(step) {
      if (!this.showRole) {
        this.params.role = null;
      }
      const obj = {
        params: this.params,
        step: 'personal',
        navigate: step,
      };
      this.$emit('navigate', obj);
    },
    updateErrors(error) {
      this.errorsCounter =
        this.errorsCounter > 0 && !error
          ? (this.errorsCounter -= 1)
          : (this.errorsCounter += 1);
    },
  },
};
</script>
